/**
 * Backend menü Page.Code / url değerlerini UI etiket + rota ile eşler.
 * documents-project-notify menüde gösterilmez (yalnızca zil yetkisi).
 */

export const MENU_LABELS_BY_CODE = {
  // DMS
  documents: "Döküman Yönetimi",
  "documents-categories": "Döküman Kategorileri",
  "documents-system": "Sistem Dökümanları",
  "documents-project-tracking": "Proje Döküman Takibi",
  "documents-project-notify": "Döküman Bildirimleri",
  "my-documents": "Belgelerim",
  // Working hours
  "calisma-saatleri": "Çalışma Saatleri",
  "giris-loglari": "Giriş Logları",
  // TCMB RIBS
  "tcmb-ribs": "TCMB Riskli İşlemler",
  "tcmb-ribs-islemler": "Riskli İşlemler",
  "tcmb-ribs-isyerleri": "Riskli İşyerleri",
  "tcmb-ribs-donemler": "Bildirim Dönemleri",
  "tcmb-ribs-loglar": "TCMB Çağrı Logları",
  "tcmb-ribs-kayitlar": "Kayıt Detayı",
  // BTrans SFP / YT
  "btrans-sfp": "BTrans GİB Bildirimleri",
  "btrans-sfp-ozet": "Bildirim Kuyruğu",
  "btrans-sfp-dosyalar": "Bildirim Dosyaları",
  "btrans-sfp-satirlar": "Bildirim Satırları",
  // Üye işyeri fesih
  "feshedilen-firmalar": "Feshedilen Firmalar",
  // Distribütör
  altimdakiler: "Altımdakiler",
  "distributor-members": "Altımdakiler",
  // Plaka / nokta
  "plaka-nokta": "Plaka ve Nokta Tanımları",
  "plaka-ve-nokta": "Plaka ve Nokta Tanımları",
  "plaka-nokta-tanimlari": "Plaka ve Nokta Tanımları",
};

export const MENU_URL_BY_CODE = {
  // DMS
  documents: "/documents/categories",
  "documents-categories": "/documents/categories",
  "documents-system": "/documents/system",
  "documents-project-tracking": "/documents/project-tracking",
  "documents-project-notify": "/documents/project-tracking",
  "my-documents": "/my-documents",
  // Working hours
  "calisma-saatleri": "/calisma-saatleri",
  "giris-loglari": "/giris-loglari",
  // TCMB RIBS
  "tcmb-ribs": "/tcmb-ribs/islemler",
  "tcmb-ribs-islemler": "/tcmb-ribs/islemler",
  "tcmb-ribs-isyerleri": "/tcmb-ribs/isyerleri",
  "tcmb-ribs-donemler": "/tcmb-ribs/donemler",
  "tcmb-ribs-loglar": "/tcmb-ribs/loglar",
  // BTrans SFP
  "btrans-sfp": "/btrans-sfp/ozet",
  "btrans-sfp-ozet": "/btrans-sfp/ozet",
  "btrans-sfp-dosyalar": "/btrans-sfp/dosyalar",
  "btrans-sfp-satirlar": "/btrans-sfp/satirlar",
  // Üye işyeri fesih
  "feshedilen-firmalar": "/feshedilen-firmalar",
  // Distribütör
  altimdakiler: "/distributor-members",
  "distributor-members": "/distributor-members",
  // Plaka / nokta
  "plaka-nokta": "/plaka-nokta",
  "plaka-ve-nokta": "/plaka-nokta",
  "plaka-nokta-tanimlari": "/plaka-nokta",
};

/** Menüde hiç gösterilmeyecek Page.Code değerleri (spec) */
export const MENU_HIDDEN_CODES = ["documents-project-notify"];

const normalizeKey = (value) =>
  String(value || "")
    .trim()
    .replace(/^\/+/, "")
    .toLowerCase();

/** url path → code anahtarı (tcmb-ribs/islemler → tcmb-ribs-islemler) */
const toCodeKey = (value) => normalizeKey(value).replace(/\//g, "-");

export const getMenuItemCode = (item) => {
  if (!item) return "";
  const raw =
    item.code || item.pageCode || item.Code || item.url || item.path || item.name;
  return toCodeKey(raw);
};

export const isHiddenMenuItem = (item) => {
  const code = getMenuItemCode(item);
  if (MENU_HIDDEN_CODES.indexOf(code) !== -1) return true;
  const url = normalizeKey(item && item.url);
  return url.indexOf("documents-project-notify") !== -1;
};

/**
 * Menü ağacını: gizli öğeleri çıkar, url/etiket düzelt.
 */
export const normalizeDmsMenuItems = (items) => {
  if (!Array.isArray(items)) return [];

  return items
    .filter((item) => item && !isHiddenMenuItem(item))
    .map((item) => {
      const code = getMenuItemCode(item);
      const next = { ...item };

      if (MENU_URL_BY_CODE[code]) {
        next.url = MENU_URL_BY_CODE[code];
      } else if (next.url && !String(next.url).startsWith("/")) {
        next.url = "/" + next.url;
      }

      if (MENU_LABELS_BY_CODE[code]) {
        next.name = MENU_LABELS_BY_CODE[code];
      } else if (next.name && typeof next.name === "string") {
        const nameKey = toCodeKey(next.name);
        if (MENU_LABELS_BY_CODE[nameKey]) {
          next.name = MENU_LABELS_BY_CODE[nameKey];
        }
      }

      if (next.children && next.children.length) {
        next.children = normalizeDmsMenuItems(next.children);
        if (next.children.length === 0) {
          delete next.children;
        }
      }

      return next;
    });
};
